import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/library/Button/Button';

import styles from '../Investments.module.css';
import { useDispatch } from 'react-redux';
import { setAccountData } from 'store/features/account/actions';
import { getSocietyPercentage, getStockNumberFromAmount } from 'utils/stock';
import InvestmentSumup from 'components/InvestmentSumup';
import { AppDispatch } from 'store/types';

interface Props {
  value: number,
  maximum: number,
  stockPrice: number,
  valuation: number,
  children: React.ReactNode,
}

export default function InvestmentsSimulation({
  value,
  maximum,
  stockPrice,
  valuation,
  children,
}: Props) {

  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();

  const getUpsell = () => {
    const percentage = Math.round(parseFloat(getSocietyPercentage(valuation, stockPrice, value)) + 1);
    return {
      percentage,
      amount: getStockNumberFromAmount(stockPrice, (percentage * valuation) / 100) * stockPrice,
    };
  };

  const handleUpsell = () => {
    dispatch(setAccountData({ investment: getUpsell().amount }));
  };

  return (
    <InvestmentSumup page="investment">
      <>
        {
          (getUpsell().amount > 0 && getUpsell().amount < maximum)
          && (
            <div className={`bounceIn ${styles.upsell}`}>
              <p>
                {`${t('investments.get')} ${getUpsell().percentage}% ${t('investments.capital')} ${getUpsell().amount.toLocaleString()} €`}
              </p>
              <Button
                label={`${t('investments.wantCTA')} ${getUpsell().percentage}% ${t('investments.capitalCTA')}`}
                variant="ghost"
                onButtonClick={handleUpsell}
                data-cy="upsell"
              />
            </div>
          )
        }
        {children}
      </>
    </InvestmentSumup>
  );
}
